import util from '@/libs/util';
export default {
  install: function install(Vue, options) {
    Vue.prototype.$ajustDialogWidth = util.ajustDialogWidth;
    Vue.prototype.$ajustBaseWidth = util.ajustBaseWidth;
    Vue.prototype.$listenElementResize = util.listenElementResize;
  }
};